<template>
  <vue-draggable-resizable
    v-if="!hideParent"
    :parent="true"
    :x="position.left"
    :y="position.top"
    :w="position.width"
    :h="position.height"
    :draggable="!isWidgetLocked"
    :resizable="allowResizing && !isWidgetLocked"
    :grid="gridScale"
    :snap="isSnapActive"
    :active="isWidgetSelected"
    :z="(isWidgetSelected && keepZIndexUp ? 1000 : 100) + widget.position[rotation].zIndex"
    :onDragStart="(x, y) => onChangePosition(true, x, y)"
    :onResizeStart="() => onChangePosition(false)"
    @dragstop="onWidgetDrag"
    @resizestop="onWidgetResize"
    @activated="() => onSelected(widget)"
    @deactivated="() => (keepZIndexUp = false)"
    @refLineParams="getRefLineParams"
  >
    <TemplateViewer ref="TemplateViewer" :template="widget.object" :zoom="scaleLayoutValue(1)" />
  </vue-draggable-resizable>
</template>

<script>
  import VueDraggableResizable from '@/components/common/VueDraggableResizable.vue';

  import playerMixins from '@/models/player';
  import draggableWidget from '@/components/layoutDesigner/mixins/draggableWidget';

  import { simpleTypeMixin } from '@/helpers';

  import TemplateViewer from '@/components/templates/viewer/TemplateViewer.vue';

  export default {
    name: 'TemplateWidget',

    components: {
      VueDraggableResizable,
      TemplateViewer,
    },

    mixins: [simpleTypeMixin, playerMixins, draggableWidget],

    props: {
      widget: {
        type: Object,
      },
    },

    computed: {
      style() {
        return {
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          backgroundColor: getRBGAColor(
            this.widget.object.backgroundColor,
            this.widget.object.opacity / 100,
          ),
        };
      },

      position() {
        return this.getPosition(this.widget, true);
      },

      allowResizing() {
        return !!this.widget.position[this.rotation].allowResizing;
      },
    },
  };
</script>

<style lang="scss" scoped>
  #layerIframe {
    overflow: hidden;
    width: 100%;
    height: 100%;
  }

  .layer {
    overflow: hidden;
  }

  .layer-link {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    text-align: center;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    color: $secondaryText;
    font-size: 32px;

    i {
      font-size: 64px;
    }
  }
</style>
